import React from 'react'

import { Credenza, CredenzaTitle } from '@/components/ui/credenza'
import DynamicCredenzaContent from '@/components/ui/credenza-content'
import Settings from '@/containers/home/settings'

interface WalletInfoModalProps {
  isOpen: boolean
  onClose: () => void
  isFixedSwap: boolean
  isBridge: boolean
}

const SwapSettingModal: React.FC<WalletInfoModalProps> = ({ isOpen, onClose, isFixedSwap, isBridge }) => {
  return (
    <Credenza open={isOpen} onOpenChange={onClose}>
      <DynamicCredenzaContent style={{ maxHeight: 'unset' }} open={isOpen} className='py-6 max-w-lg px-6'>
        <div className='flex flex-col gap-6 px-px'>
          <CredenzaTitle className='flex items-center text-size-22'>Settings</CredenzaTitle>
          <Settings isFixedSwap={isFixedSwap} isBridge={isBridge} />
        </div>
      </DynamicCredenzaContent>
    </Credenza>
  )
}

export default SwapSettingModal
